module.exports = __webpack_public_path__ + "static/media/Note-Click-Enter-Textures-Click_in_00027.4a2868c1.png";